var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { retrieveCookieValueByName, retrieveCustomerContextCookieValue } from "./cookie-finder";
import { hasCustomizationGroupValueConsent } from "../autocontextualization/autocontextualization.src";
import { getTmsInstance } from "@adeo/tms-lib";
const CONTEXT_POPOVER_SELECTOR = `[data-selectorid="context-popover"]`;
const CONTEXT_POPOVER_CTA_SELECTOR = `[data-selectorid="context-popover-cta"]`;
const CONTEXT_POPOVER_CLOSE_SELECTOR = ".mc-popover__close";
const CONTEXT_POPOVER_DISMISSED_KEY = "store-header:context-popover-dismissed";
const CONSENT_ANSWERED_COOKIE_NAME = "OptanonAlertBoxClosed";
let consentAnswered = false;
let isConsentByPassEnabled = false;
export function initContextPopover() {
  var _a;
  const contextPopovers = document.querySelectorAll(CONTEXT_POPOVER_SELECTOR);
  const openContextLayerEvent = new CustomEvent("openStoreContextLayer", {
    detail: {
      funnel_name: "Header"
    }
  });
  isConsentByPassEnabled = ((_a = contextPopovers[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('data-consent-by-pass-enabled')) === 'true';
  contextPopovers.forEach(contextPopover => {
    var _a, _b;
    (_a = contextPopover.querySelector(CONTEXT_POPOVER_CTA_SELECTOR)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
      hideContextPopover(contextPopover);
      window.dispatchEvent(openContextLayerEvent);
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'Choose my store',
          'feature_name': 'No context popover selector'
        }
      });
    });
    (_b = contextPopover.querySelector(CONTEXT_POPOVER_CLOSE_SELECTOR)) === null || _b === void 0 ? void 0 : _b.addEventListener('click', event => {
      event.preventDefault();
      dismissContextPopoverForSession();
      hideContextPopover(contextPopover);
      getTmsInstance().pushEvent(window, 'cdl_event', {
        'event_name': 'button.click',
        'event_data': {
          'button_name': 'Close button',
          'feature_name': 'No context popover selector'
        }
      });
    });
  });
  startConsentCookieObserver();
  showContextPopover();
}
function startConsentCookieObserver() {
  if (isConsentAnswered()) return;
  const intervalId = setInterval(() => {
    if (consentAnswered) {
      clearInterval(intervalId);
      return;
    }
    if (retrieveCookieValueByName(CONSENT_ANSWERED_COOKIE_NAME) !== null) {
      clearInterval(intervalId);
      consentAnswered = true;
      if (!hasCustomizationGroupValueConsent()) showContextPopover();
    }
  }, 500);
}
function isConsentAnswered() {
  return isConsentByPassEnabled || consentAnswered || retrieveCookieValueByName(CONSENT_ANSWERED_COOKIE_NAME) !== null;
}
function isConsentBannerVisible() {
  const banner = document.getElementById('onetrust-banner-sdk');
  return banner !== null && banner.style.display !== 'none' && banner.offsetParent !== null;
}
export function showContextPopover() {
  return __awaiter(this, void 0, void 0, function* () {
    if (retrieveCustomerContextCookieValue() !== null || !isConsentAnswered() || isContextPopoverDismissed() || isConsentBannerVisible()) return;
    document.querySelectorAll(CONTEXT_POPOVER_SELECTOR).forEach(contextPopover => {
      const popoverPanel = contextPopover.querySelector("[popover]");
      if (popoverPanel && !popoverPanel.classList.contains('is-visible')) {
        popoverPanel.classList.add('is-visible');
        getTmsInstance().pushEvent(window, 'cdl_event', {
          'event_name': 'popin.display',
          'event_data': {
            'popin_name': 'no context popover',
            'feature_name': 'popover store selector'
          }
        });
      }
    });
  });
}
function hideContextPopover(contextPopover) {
  const popoverPanel = contextPopover.querySelector("[popover]");
  popoverPanel === null || popoverPanel === void 0 ? void 0 : popoverPanel.classList.remove('is-visible');
}
export function isContextPopoverDismissed() {
  try {
    return sessionStorage.getItem(CONTEXT_POPOVER_DISMISSED_KEY) === "true";
  } catch (_a) {
    return false;
  }
}
function dismissContextPopoverForSession() {
  try {
    sessionStorage.setItem(CONTEXT_POPOVER_DISMISSED_KEY, "true");
  } catch (_a) {}
}